import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    withStyles,
    List,
    ListItem,
    Button,
    IconButton, TextField, Tooltip,
} from '@material-ui/core';
import { getTranslate, Translate } from 'react-localize-redux';

import {
    AddIcon, RemoveIcon, UserAccessIcon,
} from '../../../common/icons';

const styles = theme => ({
    root: {
    },
    list: {
        marginTop: theme.spacing(1),
        padding: 0,

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 0),
        },
    },
    listItem: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 0),
            flexWrap: 'wrap',
        },
    },
    textField: {
        margin: `0 ${theme.spacing(2)}px`,

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 1, 2, 0),
        },
    },
    addButton: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),

        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
        },
    },
    addIcon: {
        marginLeft: theme.spacing(1),
    },
    flex: {
        flex: '1 1 auto',
    },
    removeButton: {
        color: theme.colors.red1,
    },
    infoIcon: {
        color: theme.palette.text.secondary,
    },
    infoTooltip: {
        backgroundColor: theme.palette.grey[100],
        color: theme.colors.blue4,
        padding: theme.spacing(3),
        boxShadow: theme.shadows[1],
        fontSize: '1em',
    },
});

const createContact = () => ({
    name: '',
    role: '',
    phone: '',
    email: '',
    _newId: Date.now(), // id is created on server
});

class ContactPersons extends React.Component {
    handleChange = (index, name) => (event) => {
        this.props.onChange({
            target: {
                value: this.props.values.map((el, i) => (i === index ? { ...el, [name]: event.target.value } : el)),
            },
        });
    };

    addValue = () => {
        this.props.onChange({
            target: {
                value: this.props.values.concat(createContact()),
            },
        });
    };

    removeValue = index => () => {
        this.props.onChange({
            target: {
                value: this.props.values.filter((el, i) => i !== index),
            },
        });
    }

    render() {
        const {
            classes, translate, values,
        } = this.props;

        return (
            <div className={classes.root}>
                <List className={classes.list}>
                    {values.map((value, index) => (
                        <ListItem
                            className={classes.listItem}
                            key={value.key || value.id || value._newId}
                        >
                            <TextField
                                className={classes.textField}
                                label={translate('studentEdit.name')}
                                value={value.name || ''}
                                onChange={this.handleChange(index, 'name')}
                                // error={!!getError(name)}
                                // helperText={getError(name)}
                                InputLabelProps={{ shrink: true }}
                                required
                            />
                            <TextField
                                className={classes.textField}
                                label={translate('studentEdit.role')}
                                value={value.role || ''}
                                onChange={this.handleChange(index, 'role')}
                                // error={!!getError(role)}
                                // helperText={getError(role)}
                                InputLabelProps={{ shrink: true }}
                                required
                            />
                            <TextField
                                className={classes.textField}
                                label={translate('studentEdit.phone')}
                                value={value.phone || ''}
                                onChange={this.handleChange(index, 'phone')}
                                // error={!!getError(phone)}
                                // helperText={getError(phone)}
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                className={classes.textField}
                                label={translate('studentEdit.email')}
                                value={value.email || ''}
                                onChange={this.handleChange(index, 'email')}
                                // error={!!getError(email)}
                                // helperText={getError(email)}
                                InputLabelProps={{ shrink: true }}
                                type="email"
                            />
                            {value.userId && (
                                <Tooltip placement="left" classes={{ tooltip: classes.infoTooltip }} title={translate('studentEdit.canLogin')}>
                                    <UserAccessIcon className={classes.infoIcon} />
                                </Tooltip>
                            )}
                            <div className={classes.flex} />
                            <IconButton
                                onClick={this.removeValue(index)}
                            >
                                <RemoveIcon className={classes.removeButton} />
                            </IconButton>
                        </ListItem>
                    ))}
                </List>

                <Button
                    onClick={this.addValue}
                    color="secondary"
                    className={classes.addButton}
                >
                    <Translate id="shared.add" />
                    <AddIcon className={classes.addIcon} />
                </Button>
            </div>
        );
    }
}

ContactPersons.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(ContactPersons));
